import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import languagesList from '../../catalogs/languages.json'
import Types from '../../classes/types';
import { appConfig } from '../../services';

import FlagIcon from '../icons/FlagIcon';
import DropDown from './DropDown';

const availableLangs = appConfig.languages;

const LanguageSelector = ({
    selected = Types.LANGUAGE_EN,
    onChange = () => { },
    className,
    language,
    disabled,
}) => {
    const languages = Object.fromEntries(Object.entries(languagesList).filter(([code]) => availableLangs.includes(code)));

    const getLangName = (code) => {
        return (
            <>
                <FlagIcon flagCode={languages[code].flag} />
                {languages[code].name}
            </>
        )
    };

    return (
        <section className={classNames('LanguageSelector', className)}>
            <DropDown
                selected={{ name: getLangName(selected), value: selected }}
                options={Object.keys(languages).map((code) => ({
                    name: getLangName(code),
                    value: code
                }))}
                onChange={({ value }) => onChange(value)}
                disabled={languages.length === 1 || disabled}
                title={language}
            />
        </section>
    )
}

LanguageSelector.propTypes = {
    disabled: PropTypes.bool,
    className: PropTypes.string,
    selected: PropTypes.string,
    onChange: PropTypes.func,
};

export default LanguageSelector;